function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
function _slicedToArray(r, e) { return _arrayWithHoles(r) || _iterableToArrayLimit(r, e) || _unsupportedIterableToArray(r, e) || _nonIterableRest(); }
function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance.\nIn order to be iterable, non-array objects must have a [Symbol.iterator]() method."); }
function _unsupportedIterableToArray(r, a) { if (r) { if ("string" == typeof r) return _arrayLikeToArray(r, a); var t = {}.toString.call(r).slice(8, -1); return "Object" === t && r.constructor && (t = r.constructor.name), "Map" === t || "Set" === t ? Array.from(r) : "Arguments" === t || /^(?:Ui|I)nt(?:8|16|32)(?:Clamped)?Array$/.test(t) ? _arrayLikeToArray(r, a) : void 0; } }
function _arrayLikeToArray(r, a) { (null == a || a > r.length) && (a = r.length); for (var e = 0, n = Array(a); e < a; e++) n[e] = r[e]; return n; }
function _iterableToArrayLimit(r, l) { var t = null == r ? null : "undefined" != typeof Symbol && r[Symbol.iterator] || r["@@iterator"]; if (null != t) { var e, n, i, u, a = [], f = !0, o = !1; try { if (i = (t = t.call(r)).next, 0 === l) { if (Object(t) !== t) return; f = !1; } else for (; !(f = (e = i.call(t)).done) && (a.push(e.value), a.length !== l); f = !0); } catch (r) { o = !0, n = r; } finally { try { if (!f && null != t.return && (u = t.return(), Object(u) !== u)) return; } finally { if (o) throw n; } } return a; } }
function _arrayWithHoles(r) { if (Array.isArray(r)) return r; }
function _regenerator() { /*! regenerator-runtime -- Copyright (c) 2014-present, Facebook, Inc. -- license (MIT): https://github.com/babel/babel/blob/main/packages/babel-helpers/LICENSE */ var e, t, r = "function" == typeof Symbol ? Symbol : {}, n = r.iterator || "@@iterator", o = r.toStringTag || "@@toStringTag"; function i(r, n, o, i) { var c = n && n.prototype instanceof Generator ? n : Generator, u = Object.create(c.prototype); return _regeneratorDefine2(u, "_invoke", function (r, n, o) { var i, c, u, f = 0, p = o || [], y = !1, G = { p: 0, n: 0, v: e, a: d, f: d.bind(e, 4), d: function d(t, r) { return i = t, c = 0, u = e, G.n = r, a; } }; function d(r, n) { for (c = r, u = n, t = 0; !y && f && !o && t < p.length; t++) { var o, i = p[t], d = G.p, l = i[2]; r > 3 ? (o = l === n) && (u = i[(c = i[4]) ? 5 : (c = 3, 3)], i[4] = i[5] = e) : i[0] <= d && ((o = r < 2 && d < i[1]) ? (c = 0, G.v = n, G.n = i[1]) : d < l && (o = r < 3 || i[0] > n || n > l) && (i[4] = r, i[5] = n, G.n = l, c = 0)); } if (o || r > 1) return a; throw y = !0, n; } return function (o, p, l) { if (f > 1) throw TypeError("Generator is already running"); for (y && 1 === p && d(p, l), c = p, u = l; (t = c < 2 ? e : u) || !y;) { i || (c ? c < 3 ? (c > 1 && (G.n = -1), d(c, u)) : G.n = u : G.v = u); try { if (f = 2, i) { if (c || (o = "next"), t = i[o]) { if (!(t = t.call(i, u))) throw TypeError("iterator result is not an object"); if (!t.done) return t; u = t.value, c < 2 && (c = 0); } else 1 === c && (t = i.return) && t.call(i), c < 2 && (u = TypeError("The iterator does not provide a '" + o + "' method"), c = 1); i = e; } else if ((t = (y = G.n < 0) ? u : r.call(n, G)) !== a) break; } catch (t) { i = e, c = 1, u = t; } finally { f = 1; } } return { value: t, done: y }; }; }(r, o, i), !0), u; } var a = {}; function Generator() {} function GeneratorFunction() {} function GeneratorFunctionPrototype() {} t = Object.getPrototypeOf; var c = [][n] ? t(t([][n]())) : (_regeneratorDefine2(t = {}, n, function () { return this; }), t), u = GeneratorFunctionPrototype.prototype = Generator.prototype = Object.create(c); function f(e) { return Object.setPrototypeOf ? Object.setPrototypeOf(e, GeneratorFunctionPrototype) : (e.__proto__ = GeneratorFunctionPrototype, _regeneratorDefine2(e, o, "GeneratorFunction")), e.prototype = Object.create(u), e; } return GeneratorFunction.prototype = GeneratorFunctionPrototype, _regeneratorDefine2(u, "constructor", GeneratorFunctionPrototype), _regeneratorDefine2(GeneratorFunctionPrototype, "constructor", GeneratorFunction), GeneratorFunction.displayName = "GeneratorFunction", _regeneratorDefine2(GeneratorFunctionPrototype, o, "GeneratorFunction"), _regeneratorDefine2(u), _regeneratorDefine2(u, o, "Generator"), _regeneratorDefine2(u, n, function () { return this; }), _regeneratorDefine2(u, "toString", function () { return "[object Generator]"; }), (_regenerator = function _regenerator() { return { w: i, m: f }; })(); }
function _regeneratorDefine2(e, r, n, t) { var i = Object.defineProperty; try { i({}, "", {}); } catch (e) { i = 0; } _regeneratorDefine2 = function _regeneratorDefine(e, r, n, t) { function o(r, n) { _regeneratorDefine2(e, r, function (e) { return this._invoke(r, n, e); }); } r ? i ? i(e, r, { value: n, enumerable: !t, configurable: !t, writable: !t }) : e[r] = n : (o("next", 0), o("throw", 1), o("return", 2)); }, _regeneratorDefine2(e, r, n, t); }
function asyncGeneratorStep(n, t, e, r, o, a, c) { try { var i = n[a](c), u = i.value; } catch (n) { return void e(n); } i.done ? t(u) : Promise.resolve(u).then(r, o); }
function _asyncToGenerator(n) { return function () { var t = this, e = arguments; return new Promise(function (r, o) { var a = n.apply(t, e); function _next(n) { asyncGeneratorStep(a, r, o, _next, _throw, "next", n); } function _throw(n) { asyncGeneratorStep(a, r, o, _next, _throw, "throw", n); } _next(void 0); }); }; }
function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

import DialogsComponent from '@/components/DialogsComponent';
import UseCaseDetailComponent from '@/apps/attributes/modules/use_cases/components/UseCaseDetailComponent';
import { mapMutations, mapState } from 'vuex';
import { filterMixin } from '@/mixins/filter_mixin';
import search_engine_service from '@/apps/attributes/services/search_engine_service';
import UseCasesService from '@/apps/attributes/services/use_cases_service';
import XLSX from "xlsx";
import tasks from '@/js/tasks';
export default {
  name: 'SearchListPage',
  components: {
    DialogsComponent: DialogsComponent,
    UseCaseDetailComponent: UseCaseDetailComponent
  },
  mixins: [filterMixin],
  data: function data() {
    var STATUS_ACTIVE = 'ACTIVE';
    var STATUS_INACTIVE = 'INACTIVE';
    return {
      STATUS_ACTIVE: STATUS_ACTIVE,
      STATUS_INACTIVE: STATUS_INACTIVE,
      DIALOG_SEE_REPORT_DETAIL: 'DIALOG_SEE_REPORT_DETAIL',
      progress_all: 0,
      total_to_load: 0,
      attr_loaded: 0,
      q: '',
      isLoading: false,
      filterEnabled: true,
      slider: {
        min: 0,
        max: 100,
        range: [0, 100]
      },
      attr_selected: {},
      filtro: {
        category: [],
        category_comma: null,
        q: null,
        per_page: 25,
        page: 1,
        not_null_without_value: true,
        include_search_by_desc: true,
        semantic_search: false,
        include_search_by_extra_data: true,
        not_null_min: 0,
        not_null_max: 100,
        include_no_available: false,
        company_code: '0'
      },
      existeBusqueda: false,
      encontrado: {
        'found': 0,
        'page': 1,
        'per_page': 25,
        'q': '',
        'search_time_ms': 0,
        'busqueda': []
      },
      items_selected: [],
      pagination: {
        current: 1,
        limit: 25,
        total: 0
      },
      idioma: this.$i18n.locale,
      categories: [],
      sort_by: [],
      download_data: [],
      MAX_ATRIBUTES: 2000
    };
  },
  created: function created() {
    this.q = this.$route.query.q;
    if (location.host.indexOf("-inca.web.app") != -1 || location.host.indexOf("localhost") != -1) {
      this.MAX_ATRIBUTES = 2000;
    }
  },
  beforeMount: function beforeMount() {
    this.getCategories();
  },
  methods: _objectSpread(_objectSpread({}, mapMutations('attribute', ['setAttributes', 'addAtribute', 'removeAtribute'])), {}, {
    initData: function initData() {
      var _this = this;
      this.attributes.forEach(function (a) {
        _this.editedIndex = _this.encontrado.busqueda.findIndex(function (item) {
          return item.categoria == a.categoria && item.nombre == a.nombre;
        });
        if (_this.editedIndex >= 0) {
          _this.editedItem = Object.assign({}, a);
          Object.assign(_this.encontrado.busqueda[_this.editedIndex], _this.editedItem);
        }
      });
    },
    getValueFound: function getValueFound(a) {
      var b = a[1] + "";
      b = b.replace("á", "a").replace("é", "e").replace("í", "i").replace("ó", "o").replace("ú", "u");
      if (this.q && b.toLowerCase().indexOf(this.q.toLowerCase()) != -1) return true;
      return false;
    },
    onSelectAll: function () {
      var _onSelectAll = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee() {
        var total_pages, status, i, _status;
        return _regenerator().w(function (_context) {
          while (1) switch (_context.n) {
            case 0:
              if (!(this.filtro.category.length == 0)) {
                _context.n = 1;
                break;
              }
              tasks.toast.warning("Debe seleccionar al menos una categoría.");
              return _context.a(2);
            case 1:
              this.$refs["MODAL_SELECT_ALL"].onOpen();
              this.total_to_load = this.encontrado.found;
              this.attr_loaded = 0;
              this.progress_all = 0;
              this.filtro.per_page = 25;
              total_pages = Math.ceil(this.encontrado.found / this.filtro.per_page);
              status = true; //this.addAllItem()
              if (!(status && total_pages > 0)) {
                _context.n = 6;
                break;
              }
              i = 1;
            case 2:
              if (!(i <= total_pages)) {
                _context.n = 6;
                break;
              }
              _context.n = 3;
              return this.next(i);
            case 3:
              _status = this.addAllItem(true);
              if (_status) {
                _context.n = 4;
                break;
              }
              return _context.a(3, 6);
            case 4:
              this.attr_loaded += this.encontrado.busqueda.length;
              this.progress_all = this.attr_loaded / this.encontrado.found * 100;
            case 5:
              i++;
              _context.n = 2;
              break;
            case 6:
              this.filtro.per_page = 25;
              this.next(1);
            case 7:
              return _context.a(2);
          }
        }, _callee, this);
      }));
      function onSelectAll() {
        return _onSelectAll.apply(this, arguments);
      }
      return onSelectAll;
    }(),
    addAllItem: function addAllItem() {
      var _this2 = this;
      var only_add = arguments.length > 0 && arguments[0] !== undefined ? arguments[0] : false;
      if (this.attributes.length + this.encontrado.busqueda.length >= this.MAX_ATRIBUTES) {
        //tasks.toast.warning("Puede seleccionar máximo " + this.MAX_ATRIBUTES +" atributos.")
        //return false
      }
      var counter = 0;
      this.encontrado.busqueda.forEach(function (item) {
        if (item.status === true) {
          counter++;
        }
      });
      if (counter < this.encontrado.busqueda.length) {
        this.encontrado.busqueda.forEach(function (item) {
          if (item.status === false) {
            item.status = true;
            _this2.addAtribute(item);
          }
        });
      } else {
        if (!only_add) {
          this.encontrado.busqueda.forEach(function (item) {
            _this2.removeAtribute(item);
            item.status = false;
          });
        }
      }
      return true;
    },
    addItem: function addItem(item) {
      this.editedIndex = this.encontrado.busqueda.indexOf(item);
      this.editedItem = Object.assign({}, item);
      if (this.editedItem.status) {
        this.editedItem.status = false;
        this.removeAtribute(this.editedItem);
      } else {
        if (this.attributes.length >= this.MAX_ATRIBUTES) {
          //tasks.toast.warning("Puede seleccionar máximo " + this.MAX_ATRIBUTES +" atributos.")
          //return
        }
        this.editedItem.status = true;
        this.addAtribute(this.editedItem);
      }
      Object.assign(this.encontrado.busqueda[this.editedIndex], this.editedItem);
    },
    buscarTerminos: function () {
      var _buscarTerminos = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee2() {
        var _this3 = this;
        var arrayCategories;
        return _regenerator().w(function (_context2) {
          while (1) switch (_context2.n) {
            case 0:
              this.filtro.company_code = this.companyCode;
              this.filtro.q = '';
              this.isLoading = true;
              this.filtro.not_null_min = this.slider.range[0];
              this.filtro.not_null_max = this.slider.range[1];
              if (this.$route.query.q == null) {
                this.filtro.q = '';
              } else {
                this.filtro.q = this.$route.query.q;
              }
              if (this.$route.query.c == null) {
                this.filtro.category = [];
                this.filtro.category_comma = '';
              } else {
                this.filtro.category = [];
                this.filtro.category_comma = this.$route.query.c;
                arrayCategories = [];
                arrayCategories = this.filtro.category_comma.split(',');
                this.categories.forEach(function (x) {
                  if (arrayCategories.includes(x.id)) {
                    _this3.filtro.category.push(x);
                  }
                });
              }
              _context2.n = 1;
              return search_engine_service.getBuscadorAtributos(this.filtro).then(function (response) {
                _this3.encontrado = response;
                _this3.existeBusqueda = _this3.encontrado.found > 0;
                if (_this3.existeBusqueda) {
                  _this3.encontrado.busqueda.forEach(function (x) {
                    var metadata = _this3.formatData(x);
                    x.more_data2 = Object.assign({}, metadata);
                    x.more_data = x.more_data.filter(function (y) {
                      return _this3.getValueFound(y);
                    });
                  });
                  _this3.encontrado.busqueda = _this3.encontrado.busqueda.map(function (v) {
                    return _objectSpread(_objectSpread({}, v), {}, {
                      status: false
                    });
                  });
                  _this3.initData();
                } else {
                  _this3.encontrado.busqueda = [];
                }
                _this3.isLoading = false;
              });
            case 1:
              return _context2.a(2);
          }
        }, _callee2, this);
      }));
      function buscarTerminos() {
        return _buscarTerminos.apply(this, arguments);
      }
      return buscarTerminos;
    }(),
    formatData: function formatData(x) {
      var metadata = {
        business: {},
        relation: {}
      };
      x.more_data.forEach(function (m) {
        if (["Proyecto", "Dataset", "Tabla", "Modelos ML"].indexOf(m[0]) != -1) {
          if ("Modelos ML" == m[0]) {
            try {
              if (m[1]) {
                // to test
                if (Number.parseInt(Math.random() * 10) % 2 == 0) {
                  //m[1] = '{"INTERBANK": "AdmisionTC NBCA", "INTERBANK": "Inferencia Ingresos V2", "INTERCORP": "Modelo ITC"}'
                }
                if (m[1].startsWith("{")) metadata.relation[m[0]] = JSON.parse(m[1]);else metadata.relation[m[0]] = m[1];
              } else {
                metadata.relation[m[0]] = JSON.parse(m[1]);
              }
            } catch (error) {
              console.log(error);
            }
          } else {
            metadata.relation[m[0]] = m[1];
          }
        } else {
          metadata.business[m[0]] = m[1];
        }
      });
      return metadata;
    },
    next: function () {
      var _next2 = _asyncToGenerator(/*#__PURE__*/_regenerator().m(function _callee3(page) {
        return _regenerator().w(function (_context3) {
          while (1) switch (_context3.n) {
            case 0:
              this.filtro.page = page;
              _context3.n = 1;
              return this.buscarTerminos();
            case 1:
              this.isLoading = false;
            case 2:
              return _context3.a(2);
          }
        }, _callee3, this);
      }));
      function next(_x) {
        return _next2.apply(this, arguments);
      }
      return next;
    }(),
    sendToSearch: function sendToSearch() {
      this.filtro.page = 1;
      var listCategories = [];
      if (this.filtro.category.length > 0) {
        this.filtro.category.forEach(function (item, index) {
          listCategories.push(item.id);
        });
        this.filtro.category_comma = listCategories.join();
      } else {
        this.filtro.category_comma = '';
      }
      this.filtro.q = this.q;
      if (this.q == null) {
        this.q = '';
      }
      this.$router.push('/attributes/search/list?q=' + this.q + '&c=' + this.filtro.category_comma);
      this.buscarTerminos();
    },
    getCategories: function getCategories() {
      var _this4 = this;
      UseCasesService.getAttributeMasterCatalog().then(function (response) {
        if (response && response.data) {
          Object.entries(response.data.attribute_source_id).forEach(function (entry) {
            var eliminados = [];
            var _entry = _slicedToArray(entry, 2),
              key = _entry[0],
              value = _entry[1];
            if (value.denied_company_code) {
              Object.entries(value.denied_company_code).forEach(function (denied) {
                var _denied = _slicedToArray(denied, 2),
                  llave = _denied[0],
                  valor = _denied[1];
                eliminados.push(valor);
              });
            }
            if (!eliminados.includes(_this4.companyCode)) {
              _this4.categories.push({
                id: value.alias,
                name: _this4.idioma === 'es' ? value.name_es : value.name_en
              });
            }
          });
          _this4.buscarTerminos();
        }
      });

      // ------
    },
    cambiarIdioma: function cambiarIdioma(idioma) {
      this.idioma = idioma;
    },
    onOpenModalAdditionalData: function onOpenModalAdditionalData(item) {
      this.attr_selected = item;
      this.$refs["DIALOG_DATOS_ADICIONALES"].onOpen();
    },
    onPrepareData: function onPrepareData() {
      console.log(this.download_data);
      var data = [["Nombre", "Descripción", "Categoria", "Tipo", "Grupo", "Sub Grupo", "Categoría", "Fórmula", "Tipo de Dato", "Tipo de Atributo", "Tipo de Atributo Cuantitativo", "Empresas", "Valores de Ejemplo", "Frecuencia de Cálculo", "Inicio Historia", "Fin Historia", "¿Es inferido?", "Empresas Restringidas", "Observación", "Proyecto", "Dataset", "Tabla", "Modelos ML"]];
      this.download_data.forEach(function (attr) {
        var item = [attr.nombre, attr.descripcion, attr.categoria, attr.tipo_dato, attr.more_data2.business["Grupo"], attr.more_data2.business["Sub Grupo"], attr.more_data2.business["Categoría"], attr.more_data2.business["Fórmula"], attr.more_data2.business["Tipo de Dato"], attr.more_data2.business["Tipo de Atributo"], attr.more_data2.business["Tipo de Atributo Cuantitativo"], attr.more_data2.business["Empresas"], attr.more_data2.business["Valores de Ejemplo"], attr.more_data2.business["Frecuencia de Cálculo"], attr.more_data2.business["Inicio Historia"], attr.more_data2.business["Fin Historia"], attr.more_data2.business["¿Es inferido?"], attr.more_data2.business["Empresas Restringidas"], attr.more_data2.business["Observación"], attr.more_data2.relation["Proyecto"], attr.more_data2.relation["Dataset"], attr.more_data2.relation["Tabla"], attr.more_data2.relation["Modelos ML"]];
        data.push(item);
      });
      return data;
    },
    asyncTaskSearch: function asyncTaskSearch(page) {
      var _this5 = this;
      return new Promise(function (resolve, reject) {
        var filtro_copy = Object.assign(_this5.filtro);
        filtro_copy.page = page;
        search_engine_service.getBuscadorAtributos(filtro_copy).then(function (response) {
          var data = response;
          data.busqueda.forEach(function (meta) {
            var metadata = _this5.formatData(meta);
            meta.more_data2 = Object.assign({}, metadata);
          });
          _this5.download_data = _this5.download_data.concat(data.busqueda);
          console.log("Processing page: ".concat(page));
          resolve("Page ".concat(page, " completed"));
        });
      });
    },
    processTasksRecursivelySearch: function processTasksRecursivelySearch(total_page) {
      var _this6 = this;
      var index = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
      if (index == total_page) {
        return Promise.resolve('All page completed');
      }
      return this.asyncTaskSearch(index + 1).then(function (result) {
        console.log(result);
        // Recur with the next task
        return _this6.processTasksRecursivelySearch(total_page, index + 1);
      }).catch(function (error) {
        console.error("Error processing page ".concat(index, ": ").concat(error));
        // Optionally decide to continue or stop on error
        return _this6.processTasksRecursivelySearch(total_page, index + 1); // Continue with next task
      });
    },
    onDownloadFile: function onDownloadFile() {
      var _this7 = this;
      this.download_data = [];
      tasks.lockScreen.lock();
      this.processTasksRecursivelySearch(Math.ceil(this.encontrado.found / this.encontrado.per_page), 0).then(function (response) {
        tasks.lockScreen.unlock();
        var data = _this7.onPrepareData();
        // Create a new workbook
        var wb = XLSX.utils.book_new();

        // Convert the data to a worksheet
        var ws = XLSX.utils.aoa_to_sheet(data);

        // Append the worksheet to the workbook
        XLSX.utils.book_append_sheet(wb, ws, "Sheet1");

        // Generate a binary string representation of the workbook
        var wbout = XLSX.write(wb, {
          bookType: 'xlsx',
          type: 'binary'
        });

        // Convert the binary string to a Blob
        function s2ab(s) {
          var buf = new ArrayBuffer(s.length);
          var view = new Uint8Array(buf);
          for (var i = 0; i < s.length; i++) view[i] = s.charCodeAt(i) & 0xFF;
          return buf;
        }

        // Create a Blob from the workbook
        var blob = new Blob([s2ab(wbout)], {
          type: "application/octet-stream"
        });

        // Create a link element
        var link = document.createElement('a');

        // Create a URL for the Blob and set it as the href attribute
        link.href = URL.createObjectURL(blob);

        // Set the download attribute with a filename
        link.download = 'example.xlsx';

        // Append the link to the body
        document.body.appendChild(link);

        // Programmatically click the link to trigger the download
        link.click();

        // Remove the link from the document
        document.body.removeChild(link);
      });
    }
  }),
  watch: {
    '$i18n.locale': function $i18nLocale(newLocale) {
      this.cambiarIdioma(newLocale);
    }
  },
  computed: _objectSpread(_objectSpread(_objectSpread({}, mapState('data-platform', ['companyCode', 'companyName', 'has_semantic_search_active'])), mapState('attribute', ['attributes'])), {}, {
    getBreadcrumbs: function getBreadcrumbs() {
      return [{
        text: this.translate('attributes.discover_attributes'),
        disabled: true
      }];
    },
    breadcrums: function breadcrums() {
      return [{
        text: this.translate('menu.attrs.search_attributes'),
        disabled: false,
        href: '/#/attributes/search'
      }, {
        text: this.filtro.category.length ? this.filtro.category[0].name : '',
        disabled: true
      }];
    },
    headers: function headers() {
      if (this.filtro.include_search_by_extra_data) {
        return [{
          text: this.translate('attributes.search.table_search_list.name'),
          value: 'nombre',
          align: 'start'
        }, {
          text: this.translate('attributes.search.table_search_list.description'),
          value: 'descripcion',
          align: 'start'
        }, {
          text: this.translate('attributes.search.table_search_list.category'),
          value: 'categoria',
          align: 'center'
        }, {
          text: this.translate('attributes.search.table_search_list.data_type'),
          value: 'tipo_dato',
          align: 'center'
        },
        //{ text: this.translate('attributes.search.table_search_list.percentage'), value: 'no_nulo', align: 'end' },
        {
          text: this.translate('attributes.search.table_search_list.additional_data'),
          value: 'more'
        }, {
          text: '',
          value: 'status'
        }];
      }
      return [{
        text: this.translate('attributes.search.table_search_list.name'),
        value: 'nombre',
        align: 'start'
      }, {
        text: this.translate('attributes.search.table_search_list.description'),
        value: 'descripcion',
        align: 'start'
      }, {
        text: this.translate('attributes.search.table_search_list.category'),
        value: 'categoria',
        align: 'center'
      }, {
        text: this.translate('attributes.search.table_search_list.data_type'),
        value: 'tipo_dato',
        align: 'center'
      }, {
        text: this.translate('attributes.search.table_search_list.percentage'),
        value: 'no_nulo',
        align: 'end'
      }, {
        text: this.translate('attributes.search.table_search_list.additional_data'),
        value: 'more'
      }, {
        text: '',
        value: 'status'
      }];
    } // categories() {
    //   return [
    //     { id: 'demographic', name: this.translate('attributes.search.demographics') },
    //     { id: 'corporate', name: this.translate('attributes.search.corporate') },
    //     { id: 'retail', name: this.translate('attributes.search.Retail') },
    //     { id: 'digital', name: this.translate('attributes.search.digital') },
    //     { id: 'rcc', name: this.translate('attributes.search.RCC') },
    //     { id: 'pagos', name: this.translate('attributes.search.payments') },
    //     { id: 'seguridad', name: this.translate('attributes.search.insurance') }
    //   ]
    // }
  })
};